import {useQuery} from 'react-query';
import request from '../../axios';

interface IResponse {
  report_file: File;
}

export const getBankValidationReport = async (loanGuid?: string) => {
  const {data}: {data: IResponse} = await request.get(
    `/api/v2/payment/bank-validation/report/loan-request/` + loanGuid,
  );
  return data;
};

const useGetBankValidationReport = (loanGuid: string) => {
  const {data, isLoading, refetch} = useQuery<IResponse>(
    ['get-bank-validation-report', loanGuid],
    () => getBankValidationReport(loanGuid),
    {
      enabled: Boolean(loanGuid),
    },
  );
  return {data, isLoading, refetch};
};

export default useGetBankValidationReport;
